import { gql, useMutation } from '@apollo/client'

export const CREATE_PROJECT = gql`
  mutation ($input: CampaignCreate) {
    createCampaign(input: $input) {
      id
      name
      project_id
      artist_id
      owner_id
      info
      team_info
      active
      label_id
      main_product_id
      isaac_url {
        title
        url
      }
    }
  }
`

export const useCreateProject = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_PROJECT, {
    update(cache) {
      cache.modify({
        fields: {
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
